import { useQuery } from "@tanstack/react-query";
import { creditApi } from "@/lib/credit.api";
import { queryKeys } from "@/lib/query-keys";
import { isValidRecordId } from "@/lib/route-id";

export function usePartyCreditLots(partyId: number) {
  return useQuery({
    queryKey: queryKeys.creditLots(partyId),
    enabled: isValidRecordId(partyId),
    queryFn: () => creditApi.listLots(partyId).then((r) => r.data),
  });
}
